import { render, staticRenderFns } from "./cancelamento_detalhe.vue?vue&type=template&id=1e69b2c5&"
import script from "./cancelamento_detalhe.vue?vue&type=script&lang=js&"
export * from "./cancelamento_detalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports